export default __webpack_public_path__ + "static/output-4ca101189b6bdc416d7b60898e087b53.jpg";